import React from "../_snowpack/pkg/react.js";
import "./App.css";
import Routes from "./Wrappers/Routes/index.js";
const App = () => /* @__PURE__ */ React.createElement(Routes, null);
export default App;
